import type { CardProps } from '@mui/material/Card';
import Card from '@mui/material/Card';

interface IProps extends CardProps {
  bg?: string;
  flex?: string;
  minHeight?: string;
  padding?: string;
  rounded?: string;
  className?: string;
  eventClass?: string;
}

function AtpCard({
  flex = 'flex flex-col',
  minHeight = 'min-h-full',
  padding = 'p-3 md:p-4',
  rounded = 'rounded-xl',
  className,
  eventClass,
  bg = 'bg-background-paper',
  ...rest
}: IProps) {
  return (
    <Card
      {...rest}
      className={`${className ?? ''} ${flex} ${rounded} ${minHeight} ${padding} ${
        eventClass || ''
      } ${bg} relative border border-solid border-divider shadow-none`}
    />
  );
}

export default AtpCard;
